import { Link } from 'react-router-dom'
import { FileText, Image, QrCode, Type, Palette, Clock, Ruler, ArrowRight } from 'lucide-react'
import Card from '../components/Card'

const toolCategories = [
  {
    id: 'pdf',
    name: 'PDF Tools',
    icon: FileText,
    description: 'Merge, split, compress, and convert PDF files',
    count: 6,
    color: 'from-red-500 to-red-600',
    bgColor: 'bg-red-50',
    iconColor: 'text-red-600',
  },
  {
    id: 'image',
    name: 'Image Tools',
    icon: Image,
    description: 'Convert, compress, resize, and edit images',
    count: 8,
    color: 'from-blue-500 to-blue-600',
    bgColor: 'bg-blue-50',
    iconColor: 'text-blue-600',
  },
  {
    id: 'qr',
    name: 'QR & Barcode',
    icon: QrCode,
    description: 'Generate QR codes and barcodes',
    count: 6,
    color: 'from-green-500 to-green-600',
    bgColor: 'bg-green-50',
    iconColor: 'text-green-600',
  },
  {
    id: 'text',
    name: 'Text Tools',
    icon: Type,
    description: 'Format, convert, and analyze text',
    count: 8,
    color: 'from-purple-500 to-purple-600',
    bgColor: 'bg-purple-50',
    iconColor: 'text-purple-600',
  },
  {
    id: 'color',
    name: 'Color Tools',
    icon: Palette,
    description: 'Pick colors, generate palettes, and convert formats',
    count: 6,
    color: 'from-pink-500 to-pink-600',
    bgColor: 'bg-pink-50',
    iconColor: 'text-pink-600',
  },
  {
    id: 'time',
    name: 'Time Tools',
    icon: Clock,
    description: 'Convert timezones, calculate dates, and manage time',
    count: 8,
    color: 'from-orange-500 to-orange-600',
    bgColor: 'bg-orange-50',
    iconColor: 'text-orange-600',
  },
  {
    id: 'unit',
    name: 'Unit Converter',
    icon: Ruler,
    description: 'Convert between different units of measurement',
    count: 8,
    color: 'from-indigo-500 to-indigo-600',
    bgColor: 'bg-indigo-50',
    iconColor: 'text-indigo-600',
  },
]

export default function Tools() {
  return (
    <div className="space-y-4">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Free Online Tools - All Categories</h1>
        <p className="text-sm text-gray-600 mt-2 max-w-2xl mx-auto">
          Browse our complete collection of free online tools including PDF tools, image converters, QR code generators, text utilities, unit converters, color tools, and time calculators. All tools are free to use with no registration required.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {toolCategories.map((category) => {
          const Icon = category.icon
          return (
            <Link key={category.id} to={`/tools/${category.id}`}>
              <Card className="hover:shadow-lg transition-all duration-200 group cursor-pointer h-full">
                <Card.Body className="p-4">
                  <div className={`w-10 h-10 ${category.bgColor} rounded-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
                    <Icon className={`w-5 h-5 ${category.iconColor}`} />
                  </div>
                  <h3 className="text-base font-semibold text-gray-900 mb-1 group-hover:text-primary-600 transition-colors">
                    {category.name}
                  </h3>
                  <div className="flex items-center justify-between">
                    <span className="text-xs text-gray-500">{category.count} tools</span>
                    <ArrowRight className="w-4 h-4 text-gray-400 group-hover:text-primary-600 group-hover:translate-x-1 transition-all" />
                  </div>
                </Card.Body>
              </Card>
            </Link>
          )
        })}
      </div>
    </div>
  )
}

